/* eslint-disable max-len */
import React from 'react';
import { useObserver } from '../../CodesThatsGottaGoSomewhereElse';
import { ApiClient } from '../../api/ApiClient';
import { v2 } from '../../api/ApiInterfaceV2';
import { useLoader } from '../../platform/Hook';
import { Button, Grid } from '../../ui';
import { useResolve } from '../Container';
import { ProfileModel } from '../ProfileModel';
import { AccountModel } from '../account/AccountModel';
import { Copy, Flexer, Title } from '../dashboard/elements/LayoutElements';
import { Atlassian } from '../external/atlassian/Atlassian';
import { Slack } from '../external/slack/Slack';
import { OptionControl, OptionInfo } from './PreferencesElements';

const openWindow = (url: string) => {
    const features = 'toolbar=no,location=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width=800,height=600';
    window.open(url, 'targetWindow', features);
};

const AtlassianConfig = React.memo(() => {

    const { connections } = useObserver(useResolve(ProfileModel));
    const entry = connections.find(x => x.externalSystemType === 'atlassian-oauth');

    const onConnect = () => Atlassian.link();
    const onDisconnect = () => Atlassian.unlink();

    return <>
        <OptionInfo>
            <Title>
                Atlassian
            </Title>
            {!entry &&
                <Copy>
                    Connect your Ludi account to your Atlassian account to enable integration with Jira.
                </Copy>
            }
            {!!entry &&
                <Copy>
                    Currently connected to <a target="_blank" href={entry.externalSystemUrl} rel="noreferrer">{entry.externalSystemUrl}</a>. <br />
                    Expires: {entry.expiresAt.toLocaleString()}
                </Copy>
            }
        </OptionInfo>
        <OptionControl>
            {!entry && <Button variant="common" onAction={onConnect}>Connect</Button>}
            {!!entry && <Button variant="negative" onAction={onDisconnect}>Disconnect</Button>}
        </OptionControl>
    </>;
});

const SlackConfig = React.memo(() => {
    const api = useResolve(ApiClient);
    const me = useResolve(ProfileModel);
    const account = useObserver(useResolve(AccountModel));

    const [loading, token] = useLoader(async () => {
        const t = await api.exec(v2.slack.info());

        return t;
    }, []);

    const onConnect = () => {
        sessionStorage.setItem('slack_redirect_preferences', 'true');
        window.location.href = `/connect/slack/link?userId=${me.id}&accountId=${account.id}&redirectUrl=${window.location.href}`;
    };
    const onDisconnect = () => Slack.unlink();

    return <>
        {!loading && <>
            <OptionInfo>
                <Title>
                    Slack
                </Title>
                {!token &&
                    <Copy>
                        Connect your Ludi account to your Slack account to enable integration with Slack.
                    </Copy>
                }
                {token &&
                    <Copy>
                        You are connected to Slack.
                    </Copy>
                }
            </OptionInfo>
            <OptionControl>
                {!token && <Button variant="common" onAction={onConnect}>Connect</Button>}
                {token && <Button variant="negative" onAction={onDisconnect}>Disconnect</Button>}
            </OptionControl>
        </>}
    </>;
});

const Calendar = () => {

    const active = false;

    const onConnect = () => openWindow('/connect/nylas');
    const onDisconnect = () => openWindow('/disconnect/nylas');

    return <>
        <OptionInfo>
            <Title>Calendar Integration</Title>
            <Copy>
                Connect your calendar to Ludi and schedule your meetings and workshops from directly within the app!
            </Copy>
        </OptionInfo>
        <OptionControl>
            {!active && <Button variant="common" onAction={onConnect}>Activate</Button>}
            {active && <Button variant="negative" onAction={onDisconnect}>Deactivate</Button>}
        </OptionControl>
    </>;
};

export const ConnectionsView = () =>
    <Flexer width="42">
        <Grid columns="auto 10rem" columnGap="1rem" rowGap="2rem">
            <AtlassianConfig />
            {/* <SlackConfig /> */}
            {/* <Calendar /> */}
        </Grid>
    </Flexer>;
